// 학력 상태와 직업의 학력 조건. 새 형식 장면(sceneModel)을 쓰는 진행에만 적용한다(옛 저장은 조건 없음).
// 학력은 진로·입시 장면의 선택으로 정해진다(data/scenes.js 의 edu). 아래 직업 목록은 초안이며 고쳐 쓸 수 있다.
export const EDU_LABEL = { highschool: '고졸', vocational: '특성화고졸', college: '대학 진학' };
// 대학 진학이 필요한 직업(jobs.json 의 id). 자영업·공연·작가·개발·공무원 등은 학력 조건을 두지 않는다.
export const JOB_NEEDS_COLLEGE = new Set(['doctor', 'lawyer', 'researcher', 'teacher', 'accountant', 'investor']);

/** 학력. 장면에서 정해진 값이 없으면 학업 능력치로 어림한다. */
export function educationOf(s) {
  if (s.life?.education) return s.life.education;
  return (s.stats?.학업 ?? 0) >= 30 ? 'college' : 'highschool';
}

/** 그 직업을 시작할 학력이 되는지. 새 장면 진행이 아니면 항상 참이다. */
export function meetsEducation(s, job) {
  if (!s.sceneModel || !job) return true;
  return !JOB_NEEDS_COLLEGE.has(job.id) || educationOf(s) === 'college';
}
